<lib-library-content *ngIf="currentMenu=='library'"></lib-library-content>
<lib-pre-arrangement-content *ngIf="currentMenu=='pre-arrangement'"></lib-pre-arrangement-content>
<lib-arrangement-content *ngIf="currentMenu=='arrangement'"></lib-arrangement-content>
<lib-transactions-content *ngIf="currentMenu=='transactions'"></lib-transactions-content>
<particle-due-dates-content *ngIf="currentMenu=='dac6-due-dates'"></particle-due-dates-content>
<particle-due-dates-content *ngIf="currentMenu=='dac6-forms'"></particle-due-dates-content>

